import { isMobileDevice } from "./mobile-device";
import { applyLanguage, getLanguage } from "./ui/i18n";

applyLanguage();

// Initialize error handling before any game module executes its static imports.
if (location.pathname === "/admin/settings") {
  const { mountAdminSettings } = await import("./ui/AdminSettings");
  mountAdminSettings();
} else if (isMobileDevice()) {
  // Gate direct game and invitation links before telemetry, WebGL, or audio starts.
  const search = new URLSearchParams(location.search);
  // The server redirects /?room=... to /play, so carry it under a landing-only key.
  if (search.has("room")) {
    search.set("desktopRoom", search.get("room") ?? "");
    search.delete("room");
  }
  location.replace(
    `${getLanguage() === "en" ? "/en/" : "/"}${search.size ? `?${search}` : ""}#desktop-link`,
  );
} else {
  const { listenForInstall } = await import("./ui/install-prompt");
  listenForInstall();
  const manifest = document.createElement("link");
  manifest.rel = "manifest";
  manifest.href = "/manifest.webmanifest";
  document.head.append(manifest);
  const { initializeClientTelemetry } = await import("./telemetry/client");
  await initializeClientTelemetry();
  await import("./game");
  if (location.hash === "#credits") {
    const { showMenuPage } = await import("./ui/hud/screens/menu");
    showMenuPage("guide");
  }
}
